import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authRegister, authLogout, authMe } from "@/lib/api";

const AuthContext = createContext({
  user: null,
  loading: true,
  login: async () => {},
  register: async () => {},
  logout: async () => {},
  refresh: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await authMe();
      setUser(data);
    } catch {
      setUser(null);
      localStorage.removeItem("tci-token");
    }
  }, []);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("tci-token");
      if (token) {
        await refresh();
      }
      setLoading(false);
    })();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await authLogin({ email, password });
    if (data.token) localStorage.setItem("tci-token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await authRegister({ name, email, password });
    if (data.token) localStorage.setItem("tci-token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await authLogout(); } catch {}
    localStorage.removeItem("tci-token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
